import { Box, SxProps } from "@mui/material";
import { CSSProperties, FC, PropsWithChildren } from "react";

type ButtonContainerProps = {
  sx?: SxProps;
  fixedFlowDirection?: CSSProperties["flexDirection"];
};

const ButtonContainer: FC<PropsWithChildren<ButtonContainerProps>> = ({
  children,
  fixedFlowDirection,
  sx = {}
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: { xs: "center", md: "flex-start" },
      alignItems: { xs: "initial", md: "flex-end" },
      flexDirection: fixedFlowDirection ?? { xs: "column", md: "row" },
      whiteSpace: "nowrap",
      gap: 3,
      ...sx
    }}>
    {children}
  </Box>
);

export default ButtonContainer;
